<template>
  <div class="staff">
    <c-tab :tabs="tabs" v-loading="loading"></c-tab>
  </div>
</template>

<script>
import CTab from '@/components/common/tab'
import * as types from '@/store/mutation-types'

export default {
  name: 'staff',
  components: { CTab },
  data () {
    return {
      active: '0',
      loading: false,
      tabs: [
        {
          label: '基本信息',
          component: () => import('./#basic')
        }, {
          label: '详细信息',
          component: () => import('./#detail')
        }, {
          label: '离职人员',
          component: () => import('./#dimission')
        }, {
          label: '考勤信息',
          component: () => import('./#attendance')
        }, {
          label: '薪资明细',
          component: () => import('./#salary')
        }, {
          label: '文件上传',
          component: () => import('./#filebackup')
        }
      ]
    }
  },
  watch: {
    $route: {
      handler: function() {
        const crumbs = {
          path: this.$route.path,
          tabs: this.tabs
        }
        this.$store.commit(types.RECORD_GLOBAL_CRUMBSECOND, crumbs)
      },
      immediate: true
    }
  },
  created() {
    this.loading = true
    this.$http.post(`/yuangong/delete2`).then(res => {
      if (!res.data || res.data.code === 402) {
        this.tabs.splice(1, 3)
      }
    }).finally(() => {
      this.loading = false
    })
  }
}
</script>

<style lang="scss">
.staff {
  .cell img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    cursor: pointer;
  }
}
</style>
